import type { ReactNode } from 'react'
import React from 'react'
import { View } from 'react-native'
import { tv } from 'tailwind-variants'

import { SomethingWentWrongIllustration } from './illustration'

const somethingWentWrong = tv({
  slots: {
    sizeWrapper: 'w-full max-w-[600px] p-5',
    container: 'flex w-full flex-row justify-center',
    image: 'w-full max-w-[600px]',
    contentContainer:
      'relative mx-0 my-8 flex flex-col items-center justify-center md:my-20 lg:my-40',
    mainContentContainer: 'relative flex flex-col items-center gap-y-12',
    childrenContainer: 'flex flex-col items-center gap-y-2.5',
    buttonsContainer: 'grid w-full grid-flow-row gap-4 md:grid-flow-col',
  },
})

interface Props {
  children: NonNullable<ReactNode>
  buttons: NonNullable<ReactNode>
}
export const SomethingWentWrong = (props: Props) => {
  const {
    container,
    sizeWrapper,
    image,
    buttonsContainer,
    contentContainer,
    mainContentContainer,
  } = somethingWentWrong()
  return (
    <View className={container()}>
      <View className={sizeWrapper()}>
        <View className={contentContainer()}>
          <View className={mainContentContainer()}>
            <SomethingWentWrongIllustration className={image()} />
            <View className="">{props.children}</View>
            <View className={buttonsContainer()}>{props.buttons}</View>
          </View>
        </View>
      </View>
    </View>
  )
}
